import React, { useState } from 'react';
import RegisterStudent from '../components/admin/RegisterStudent';
import ManageProjects from '../components/admin/ManageProjects';
import ReviewSubmissions from '../components/admin/ReviewSubmissions';
import StudentList from '../components/admin/StudentList';

function AdminDashboard({ user, onLogout }) {
    const [activeTab, setActiveTab] = useState('students');

    const renderContent = () => {
        switch (activeTab) {
            case 'students':
                return <StudentList />;
            case 'register':
                return <RegisterStudent />;
            case 'projects':
                return <ManageProjects />;
            case 'submissions':
                return <ReviewSubmissions />;
            default:
                return <StudentList />;
        }
    };

    return (
        <div className="dashboard">
            <header className="dashboard-header">
                <div className="header-content">
                    <div className="header-left">
                        <h1>Admin Dashboard</h1>
                        <p className="company-name">Novantix Innovation Technology</p>
                    </div>
                    <div className="header-right">
                        <span className="user-name">Welcome, {user.name}</span>
                        <button onClick={onLogout} className="btn btn-secondary">
                            Logout
                        </button>
                    </div>
                </div>
            </header>

            <div className="dashboard-container">
                <nav className="dashboard-sidebar">
                    <button
                        className={`nav-item ${activeTab === 'students' ? 'active' : ''}`}
                        onClick={() => setActiveTab('students')}
                    >
                        <span className="icon">👥</span>
                        Students
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'register' ? 'active' : ''}`}
                        onClick={() => setActiveTab('register')}
                    >
                        <span className="icon">➕</span>
                        Register Student
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'projects' ? 'active' : ''}`}
                        onClick={() => setActiveTab('projects')}
                    >
                        <span className="icon">📁</span>
                        Manage Projects
                    </button>
                    <button
                        className={`nav-item ${activeTab === 'submissions' ? 'active' : ''}`}
                        onClick={() => setActiveTab('submissions')}
                    >
                        <span className="icon">📝</span>
                        Review Submissions
                    </button>
                </nav>

                <main className="dashboard-content">{renderContent()}</main>
            </div>
        </div>
    );
}

export default AdminDashboard;
